import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { useTranslation } from 'react-i18next';

/**
 * Campo indirizzo e-mail dedicato alle comunicazioni di cortesia,
 * distinto dalle e-mail associate al procedimento. Visibilità e
 * obbligatorietà sono derivate dallo schema: quando il canale e-mail
 * è disattivo il campo viene strippato e il FormItem si nasconde.
 */
export function NotificationEmailField() {
  const { t } = useTranslation();

  return (
    <FormItem
      name="notificaEmail"
      label={t('user.settings.notification-email', 'Indirizzo e-mail')}
      help={t(
        'user.settings.notification-email-help',
        'Indirizzo dedicato alle comunicazioni di cortesia, distinto dalle e-mail indicate nelle pratiche.',
      )}
    >
      <TextInput
        name="notificaEmail"
        placeholder={t(
          'user.settings.notification-email-placeholder',
          'nome@esempio.it',
        )}
      />
    </FormItem>
  );
}
